import { useSoftDeployAccess } from './featureHelper';

const useInboxAccess = (): boolean => useSoftDeployAccess('AGENT_INBOX');

export default useInboxAccess;
